import {
  Sprite,
  Loader,
  Point,
  AnimatedSprite,
} from 'pixi.js';
import gsap from 'gsap';
import Actor from './Actor';
import vars from '../vars';

class PowerDownLevel extends Actor {
  constructor(parent, level) {
    super(parent);
    this.level = level;

    this._hidden = true;

    this.ref = new Sprite();
    if (this.level === 1) {
      this.left = new AnimatedSprite(
        Object.values(Loader.shared.resources['video/BRANCHES_LEFT_1'].spritesheet.textures),
      );
      this.right = new AnimatedSprite(
        Object.values(Loader.shared.resources['video/BRANCHES_RIGHT_1'].spritesheet.textures),
      );
    } else if (this.level === 2) {
      this.left = new AnimatedSprite(
        Object.values(Loader.shared.resources['video/BRANCHES_LEFT_2'].spritesheet.textures),
      );
      this.right = new AnimatedSprite(
        Object.values(Loader.shared.resources['video/BRANCHES_RIGHT_2'].spritesheet.textures),
      );
    } else {
      this.left = new AnimatedSprite(
        Object.values(Loader.shared.resources['video/BRANCHES_LEFT_3'].spritesheet.textures),
      );
      this.right = new AnimatedSprite(
        Object.values(Loader.shared.resources['video/BRANCHES_RIGHT_3'].spritesheet.textures),
      );
    }
    this.ref.addChild(this.left);
    this.ref.addChild(this.right);

    this.left.loop = false;
    this.right.loop = false;
    this.left.animationSpeed = 0.45;
    this.right.animationSpeed = 0.45;

    this.resize();

    this.parent.addChild(this.ref);
  }

  resize() {
    this.left.anchor = new Point(0, 0.5);
    this.left.position.x = 0;
    this.left.position.y = this.level === 1 ? vars.layout.FIRST_POWER_DONW_TOP : vars.layout.SECOND_POWER_DONW_TOP;

    this.right.anchor = new Point(1, 0.5);
    this.right.position.x = vars.layout.STAGE_WIDTH;
    this.right.position.y = this.level === 1 ? vars.layout.FIRST_POWER_DONW_TOP : vars.layout.SECOND_POWER_DONW_TOP;
  }

  get hidden() {
    return this._hidden;
  }

  set hidden(value) {
    this._hidden = value;
    if (this._hidden) {
      this.left.gotoAndStop(0);
      this.right.gotoAndStop(0);
    } else {
      this.left.play();
      this.left.onComplete = () => {
        gsap.to(this.left.position, {
          y: `+=${10}`,
          x: `-=${20}`,
          repeat: -1,
          yoyo: true,
          delay: 0.1,
          duration: 4,
          ease: 'power2.inOut',
        });
      };
      this.right.play();
      this.right.onComplete = () => {
        gsap.to(this.right.position, {
          y: `-=${10}`,
          x: `+=${20}`,
          repeat: -1,
          yoyo: true,
          delay: 0.4,
          duration: 4,
          ease: 'power2.inOut',
        });
      };
    }
  }
}

export default PowerDownLevel;
